import { MapPin, User, Clock, ChevronRight } from 'lucide-react';
import { format } from 'date-fns';
import { tr } from 'date-fns/locale';
import { StatusBadge, PriorityBadge } from './StatusBadge';
import { Building2 } from 'lucide-react';
import { STATUS_BORDER, formatJobNumber } from '../../utils/constants';
import { isOverdue } from '../../utils/jobFilters';

export function JobCard({ job, onClick }) {
  const overdue = isOverdue(job);
  return (
    <div
      onClick={() => onClick(job)}
      className={`bg-white rounded-xl border-l-4 border border-slate-200 ${STATUS_BORDER[job.status]} p-4 cursor-pointer hover:shadow-md transition-shadow`}
    >
      <div className="flex items-start justify-between gap-2 mb-2">
        <div className="min-w-0">
          {job.job_number && (
            <span className="text-xs font-mono text-slate-400 block mb-0.5">{formatJobNumber(job.job_number)}</span>
          )}
          <h3 className="font-semibold text-slate-800 leading-tight line-clamp-2">{job.title}</h3>
        </div>
        <ChevronRight size={16} className="text-slate-400 shrink-0 mt-0.5" />
      </div>

      <div className="flex flex-wrap gap-2 mb-3">
        <StatusBadge status={job.status} />
        <PriorityBadge priority={job.priority} />
        {overdue && (
          <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-xs font-semibold bg-red-100 text-red-700">
            <Clock size={11} />
            Gecikti
          </span>
        )}
      </div>

      <div className="space-y-1.5 text-xs text-slate-500">
        {job.assigned_to_name && (
          <div className="flex items-center gap-1.5">
            <User size={12} />
            <span>{job.assigned_to_name}</span>
          </div>
        )}
        {job.address && (
          <div className="flex items-center gap-1.5">
            <MapPin size={12} />
            <span className="truncate">{job.address}</span>
          </div>
        )}
        {job.customer_name && (
          <div className="flex items-center gap-1.5">
            <Building2 size={12} />
            <span className="truncate">{job.customer_name}</span>
          </div>
        )}
        {(job.due_at || job.scheduled_at) && (
          <div className={`flex items-center gap-1.5 ${overdue ? 'text-red-600 font-semibold' : ''}`}>
            <Clock size={12} />
            <span>{format(new Date(job.due_at || job.scheduled_at), 'd MMM HH:mm', { locale: tr })}</span>
          </div>
        )}
      </div>
    </div>
  );
}
